/* twinelab theme scripts */

/* ---- mobile navigation ---- */
(function(){
  function closeAll(except){
    document.querySelectorAll('.menu-toggle[aria-expanded="true"]').forEach(function(btn){
      if(btn === except) return;
      btn.setAttribute('aria-expanded','false');
      var id = btn.getAttribute('aria-controls');
      var menu = id ? document.getElementById(id) : null;
      if(menu) menu.hidden = true;
    });
  }

  document.addEventListener('click', function(e){
    var toggle = e.target.closest('.menu-toggle');
    if(toggle){
      var id = toggle.getAttribute('aria-controls');
      var menu = id ? document.getElementById(id) : null;
      if(!menu) return;
      var opening = toggle.getAttribute('aria-expanded') !== 'true';
      closeAll(toggle);
      toggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
      menu.hidden = !opening;
      return;
    }
    if(!e.target.closest('nav')) closeAll();
  });

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape') closeAll();
  });
})();

/* ---- product gallery thumb swap ---- */
function twSwapProductImage(t){
  if(!t || !t.matches('.product-gallery .thumbs img')) return;
  var main = document.querySelector('.product-gallery .main img');
  if(main){
    main.src = t.getAttribute('data-full') || t.src;
    if(t.alt) main.alt = t.alt;
  }
}
document.addEventListener('click',function(e){
  twSwapProductImage(e.target);
});
document.addEventListener('keydown',function(e){
  if((e.key === 'Enter' || e.key === ' ') && e.target.matches('.product-gallery .thumbs img')){
    e.preventDefault();
    twSwapProductImage(e.target);
  }
});

/* ---- product variant selection ---- */
(function(){
  var form = document.querySelector('[data-product-form]');
  if(!form) return;
  var variants = window.__twVariants || [];
  var priceEl = document.querySelector('[data-price]');
  var idInput = form.querySelector('input[name="id"]');
  var addBtn  = form.querySelector('.btn-add');
  var groups = form.querySelectorAll('.opt-group');
  var optionCount = groups.length;

  function currentSelections(){
    var sels = [];
    for(var i = 1; i <= optionCount; i++){
      var checked = form.querySelector('input[name="option' + i + '"]:checked');
      sels.push(checked ? checked.value : null);
    }
    return sels;
  }

  function findVariant(sels){
    for(var i = 0; i < variants.length; i++){
      var v = variants[i];
      var ok = true;
      for(var j = 0; j < sels.length; j++){
        if(sels[j] === null) continue;
        if(String(v.options[j]) !== String(sels[j])){ ok = false; break; }
      }
      if(ok) return v;
    }
    return null;
  }

  function update(){
    var sels = currentSelections();
    var match = findVariant(sels);
    if(!match){
      if(addBtn){ addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
      return;
    }

    if(idInput) idInput.value = match.id;
    if(priceEl && match.price_formatted){
      var html = match.price_formatted;
      if(match.compare_at_price_formatted){
        html += '<span class="compare">' + match.compare_at_price_formatted + '</span>';
      }
      priceEl.innerHTML = html;
    }
    if(addBtn){
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? 'Add to bag' : 'Sold out';
    }

    if(window.history && window.history.replaceState && match.id){
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  form.addEventListener('change', update);
  update();
})();

/* ---- cart quantity stepper (- / +) with mobile-safe automatic update ---- */
(function(){
  var cartForm = document.querySelector('.cart-wrap form');
  if(!cartForm) return;

  var updateButton = cartForm.querySelector('button[name="update"]');
  var updateTimer = null;
  var updating = false;

  function normaliseQuantity(input){
    var val = parseInt(input.value, 10);
    val = isNaN(val) ? 0 : Math.max(0, val);
    input.value = val;
    return val;
  }

  function normalFormUpdate(){
    updating = false;
    cartForm.removeAttribute('aria-busy');

    /* The visible Update button is known to work even in in-app browsers. */
    if(updateButton){
      updateButton.click();
      return;
    }

    /* Last-resort native submit fallback. */
    try{
      HTMLFormElement.prototype.submit.call(cartForm);
    }catch(err){
      cartForm.submit();
    }
  }

  function sendCartUpdate(){
    if(updating) return;
    updating = true;
    cartForm.setAttribute('aria-busy', 'true');

    /*
      Use Shopify's Ajax Cart API instead of requestSubmit(). Some mobile
      in-app browsers (including Instagram's webview) can be unreliable with
      programmatic submitters, while FormData + fetch works consistently.
      Shopify accepts a serialized cart form at cart/update.js.
    */
    if(typeof window.fetch !== 'function' || typeof window.FormData !== 'function'){
      normalFormUpdate();
      return;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var endpoint = root + 'cart/update.js';
    var formData = new FormData(cartForm);

    window.fetch(endpoint, {
      method: 'POST',
      body: formData,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
    .then(function(response){
      if(!response.ok) throw new Error('Cart update failed');
      return response.json();
    })
    .then(function(){
      window.location.reload();
    })
    .catch(function(){
      normalFormUpdate();
    });
  }

  function scheduleCartUpdate(){
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(sendCartUpdate, 350);
  }

  cartForm.addEventListener('click', function(e){
    var btn = e.target.closest ? e.target.closest('.qty-btn') : null;
    if(!btn) return;
    e.preventDefault();

    var wrap = btn.closest ? btn.closest('.qty-stepper') : btn.parentNode;
    var input = wrap && wrap.querySelector('input[type="number"]');
    if(!input) return;

    var val = normaliseQuantity(input);
    if(btn.hasAttribute('data-qty-plus')) val += 1;
    if(btn.hasAttribute('data-qty-minus')) val = Math.max(0, val - 1);
    input.value = val;

    scheduleCartUpdate();
  });

  cartForm.addEventListener('change', function(e){
    var target = e.target;
    if(!target || !target.matches('.qty-stepper input[type="number"]')) return;
    normaliseQuantity(target);
    scheduleCartUpdate();
  });

  /* If the customer explicitly presses Update or Checkout, don't race it. */
  cartForm.addEventListener('submit', function(){
    window.clearTimeout(updateTimer);
  });
})();

/* ---- customer address country defaults ---- */
(function(){
  document.querySelectorAll('select[name="address[country]"][data-default]').forEach(function(select){
    var wanted = select.getAttribute('data-default');
    if(!wanted) return;
    for(var i = 0; i < select.options.length; i++){
      if(select.options[i].value === wanted || select.options[i].text === wanted){
        select.selectedIndex = i;
        break;
      }
    }
  });
})();
